import { TableColumns } from '@ohpen/enso-ui';
import { FieldType, ChangeRequestResponse } from '@pmp/api';

export const columns: TableColumns<ChangeRequestResponse> = [
  {
    title: 'global.labels.id',
    dataIndex: 'actionId',
    key: 'actionId',
    options: {
      filter: 'search',
      sorter: true,
    },
    width: 300,
  },
  {
    title: 'global.labels.createdAt',
    dataIndex: 'creationTime',
    key: 'creationTime',
    options: {
      format: {
        type: 'dateTime',
      },
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'global.labels.createdBy',
    dataIndex: 'createdBy',
    key: 'createdBy',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'global.labels.entityType',
    dataIndex: 'actionEntityType',
    key: 'actionEntityType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_ENTITY_TYPE,
    },
  },
  {
    title: 'global.labels.type',
    dataIndex: 'actionType',
    key: 'actionType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_TYPE,
    },
  },
  {
    title: 'global.labels.status',
    dataIndex: 'status',
    key: 'status',
    options: {
      format: {
        type: 'tag',
      },
      filter: 'select',
      listName: FieldType.ACTION_STATUS,
      sorter: true,
    },
  },
  {
    title: 'global.labels.reviewedAt',
    dataIndex: 'timeOfReview',
    key: 'timeOfReview',
    options: {
      format: {
        type: 'dateTime',
      },
      filter: 'search',
      sorter: true,
    },
    width: 140,
  },
  {
    title: 'global.labels.reviewedBy',
    dataIndex: 'reviewedBy',
    key: 'reviewedBy',
    options: {
      filter: 'search',
      sorter: true,
    },
    width: 140,
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 120, fixed: 'right' },
];
